import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const FirmwareCardMainContainer = styled.div`
  border-radius: ${pxToRem('16px')};
  padding: ${pxToRem('24px')} ${pxToRem('30px')};
  margin: ${pxToRem('40px')} -${pxToRem('30px')} -${pxToRem('60px')} -${pxToRem('30px')};
`;
